import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormRadioGroup,
  title: 'Radio Group',
  category: ComponentCategory.FormControls,
};
